import React from "react";
import AcquireWebComponent from "../../framework/MaterialUI";
import { splitNumber, getUrlParameterByName } from "../../../utils/utility";
import sortBy from "lodash/sortBy";
import find from "lodash/find";
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  ReferenceLine,
  Tooltip,
} from "recharts";
import Select from "react-select";

import { map } from "lodash";

const CustomTooltip = ({ active, payload, total, type, measure }) => {
  if (active) {
    return (
      <div
        className="recharts-default-tootip no-margin pt-10 pl-20 pr-20 pb-15"
        style={{ background: "#000", border: "solid 1px #000", color: "#FFF" }}
      >
        <p className="recharts-tooltip-label no-margin" />
        <ul className="recharts-tooltip-item-list no-padding no-margin">
          <li
            className="recharts-tooltip-item"
            style={{
              display: "inline",
              paddingTop: "4px",
              paddingBottom: "4px",
              width: "100%",
            }}
          >
            <div
              style={{
                width: "auto",
                height: "25px",
                display: "block",
                overflow: "overlap",
                whiteSpace: "nowrap",
                textOverflow: "unset",
                borderBottom: "solid 1px #CCC",
              }}
            >
              <div className="recharts-tooltip-label no-margin-left no-margin-top no-margin-right mb-5">
                <strong>{payload[0].payload.segmentName}</strong>
              </div>
            </div>
          </li>
          <li
            className="recharts-tooltip-item"
            style={{
              display: "inline",
              paddingTop: "4px",
              paddingBottom: "4px",
              width: "100%",
            }}
          >
            <div
              style={{
                width: "auto",
                height: "20px",
                display: "block",
                overflow: "overlap",
                whiteSpace: "nowrap",
                textOverflow: "unset",
              }}
            >
              <p className="recharts-tooltip-label no-margin-bottom no-margin-left no-margin-right mt-5">
                Segment - {payload[0].payload.segmentCode}
              </p>
            </div>
          </li>
          <li
            className="recharts-tooltip-item"
            style={{
              display: "inline",
              paddingTop: "4px",
              paddingBottom: "4px",
              width: "100%",
            }}
          >
            <div
              style={{
                width: "auto",
                height: "20px",
                display: "block",
                overflow: "overlap",
                whiteSpace: "nowrap",
                textOverflow: "unset",
              }}
            >
              {measure === 0 ? (
                <p className="recharts-tooltip-label no-margin-left no-margin-right mt-10">
                  Pct. of HH Visitors -{" "}
                  {(
                    payload[0].payload.householdVisitors / total
                  ).toLocaleString(undefined, {
                    style: "percent",
                    minimumFractionDigits: 2,
                  })}
                </p>
              ) : (
                <p className="recharts-tooltip-label no-margin-left no-margin-right mt-10">
                  Index - {payload[0].payload.segmentIndex + 100}
                </p>
              )}
            </div>
          </li>
          {type === "psycle_premier" && (
            <li
              className="recharts-tooltip-item"
              style={{
                display: "inline",
                paddingTop: "4px",
                paddingBottom: "4px",
                width: "100%",
              }}
            >
              <div
                style={{
                  width: "auto",
                  height: "20px",
                  display: "block",
                  overflow: "overlap",
                  whiteSpace: "nowrap",
                  textOverflow: "unset",
                }}
              >
                <p className="recharts-tooltip-label no-margin-left no-margin-right mt-10">
                  IPA - {payload[0].payload.ipa}
                </p>
              </div>
            </li>
          )}
          {type === "connexions" && (
            <li
              className="recharts-tooltip-item"
              style={{
                display: "inline",
                paddingTop: "4px",
                paddingBottom: "4px",
                width: "100%",
              }}
            >
              <div
                style={{
                  width: "auto",
                  height: "20px",
                  display: "block",
                  overflow: "overlap",
                  whiteSpace: "nowrap",
                  textOverflow: "unset",
                }}
              >
                <p className="recharts-tooltip-label no-margin-left no-margin-right mt-10">
                  Technodoption Class - {payload[0].payload.technodoptionClass}
                </p>
              </div>
            </li>
          )}
        </ul>
      </div>
    );
  }

  return null;
};
const AxisLabel = ({ axisType, x, y, width, height, stroke, children }) => {
  const isVert = axisType === "yAxis";
  const cx = isVert ? x : x + width / 2;
  const cy = isVert ? height / 2 + y : y + height + 10;
  const rot = isVert ? `270 ${cx} ${cy}` : 0;
  return (
    <text
      x={cx}
      y={cy}
      transform={`rotate(${rot})`}
      fontWeight="bold"
      textAnchor="middle"
      stroke={stroke}
    >
      {children}
    </text>
  );
};
const CustomizedLabel = React.createClass({
  render() {
    const { viewBox, value } = this.props;

    return (
      <text
        x={viewBox.x}
        y={viewBox.height / 2 + viewBox.y}
        fontSize={10}
        textAnchor="middle"
      >
        {value}
      </text>
    );
  },
});

class SegmentHouseHold extends AcquireWebComponent {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: -1,
      measureIndex: props.measure === "index" ? 1 : 0,
      topIndex: props.topCount,
      topCount: props.topCount,
    };
  }

  handleMeasureChanged(e) {
    this.setState({
      measureIndex: e.value,
    });
    this.props.changeMeasure(e.value === 1 ? "index" : "hh");
  }

  handleTopNumberChange(e) {
    this.setState(
      {
        topCount: e.value,
        topIndex: e.value,
      },
      () => {
        this.props.changeTopCount(e.value);
      },
    );
  }

  render() {
    const {
      data,
      totalHouseholdVisitors,
      totalVisits,
      type,
      systems,
      zip11Households,
      zip9Households,
    } = this.props;
    const sysType = type === "default" ? getUrlParameterByName("type") : type;
    const system = find(systems, s => {
      return parseInt(s.id, 10) === parseInt(sysType, 10);
    });
    const prevSortData = sortBy(data, "segmentCode");
    const measureOptions = [
      { value: 0, label: "Household Visitors" },
      { value: 1, label: "Index" },
    ];
    const topCountOptions = [
      { value: 1, label: "1" },
      { value: 2, label: "2" },
      { value: 3, label: "3" },
      { value: 4, label: "4" },
      { value: 5, label: "5" },
      { value: 6, label: "6" },
      { value: 7, label: "7" },
      { value: 8, label: "8" },
      { value: 9, label: "9" },
      { value: 10, label: "10" },
      { value: 0, label: "All" },
    ];
    const sortData = [];
    let segment_title_name = system ? system.name : "";
    let segment_title_right =
      " Segment"; /*
      segment_title_name.toLowerCase().indexOf("connexions") >= 0
        ? " Segment"
        : " Premier Segment";*/

    if (
      segment_title_name.split(" ").length > 1 &&
      segment_title_name.split(" ")[0] !== "Purple"
    ) {
      const s = segment_title_name.split(" ")[1];
      segment_title_name = segment_title_name.split(" ")[0];
      segment_title_right = s + " Segment";
    }
    map(prevSortData, data => {
      sortData.push({
        ...data,
        total: totalHouseholdVisitors,
        pctHouseholdVisitors: (
          (data.householdVisitors / totalHouseholdVisitors) *
          100
        ).toFixed(2),
        segmentIndex: data.segmentIndex - 100,
      });
    });
    const highLightIds = map(
      sortBy(
        data,
        this.state.measureIndex === 0 ? "householdVisitors" : "segmentIndex",
      ).reverse(),
      "segmentCode",
    ).slice(0, this.state.topIndex === 0 ? data.length : this.state.topIndex);
    return (
      <div
        style={{ position: "relative", fontSize: "16px" }}
        className={
          this.state.measureIndex === 0
            ? "house-hold-chart"
            : "house-hold-index-chart"
        }
      >
        <div
          style={{ display: "flex", height: "60px" }}
          className="segment-household-nav-container"
        >
          <div style={{ flex: "1 1" }}>
            View{" "}
            <Select
              value={this.state.topCount}
              name=""
              clearable={false}
              options={topCountOptions}
              searchable={false}
              className={"top-segment-count-select"}
              onChange={this.handleTopNumberChange.bind(this)}
            />{" "}
            top segments
            {
              " " /*
            <button
              href="#"
              onClick={() => {
                this.refreshStatData();
              }}
              disabled={this.state.topIndex === this.state.topCount}
              className="btn-aa-claritas btn-claritas ml-10"
            >
              Submit
            </button>*/
            }
          </div>
          <div style={{ flex: "1 1" }}>
            <Select
              value={this.state.measureIndex}
              name=""
              clearable={false}
              options={measureOptions}
              searchable={false}
              className={"measure-select"}
              onChange={this.handleMeasureChanged.bind(this)}
            />
            <strong style={{ float: "right", marginTop: "10px" }}>
              Measure
            </strong>
          </div>
        </div>
        <div
          style={{ height: "30px", display: "none" }}
          className="sgemnt-household-pdf-nav ml-20 mb-10 mr-20 light-grey-border-bottom"
        >
          <div style={{ flex: "0 0 40%" }}>
            <span>
              <strong>
                {" "}
                {this.state.topCount === 0
                  ? "All Segments"
                  : `Top ${this.state.topCount} Segments`}
              </strong>
            </span>
          </div>
          <div style={{ flex: "1 1 50%", textAlign: "right" }}>
            <span>
              <strong>Measure: </strong>
            </span>
            <span className="ml-20">
              <strong>
                {this.state.measureIndex === 0 ? "Household Visitors" : "Index"}
              </strong>
            </span>
          </div>
        </div>
        <div
          style={{
            zIndex: "2000",
            textAlign: "center",
            minHeight: "58px",
            marginTop: "-15px",
            marginBottom: "20px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              fontSize: "55px",
              color: "#00A3AD",
              fontWeight: "bold",
            }}
          >
            {splitNumber(totalVisits)()}
          </div>
          <div
            style={{
              fontSize: "18px",
              margin: "0 10px",
              flexShrink: 0,
            }}
          >
            {" "}
            Visits by
          </div>
          <div
            style={{
              fontSize: "55px",
              color: "#00A3AD",
              fontWeight: "bold",
            }}
          >
            {" "}
            {splitNumber(totalHouseholdVisitors)()}
          </div>
          <div
            style={{
              fontSize: "18px",
              marginLeft: "10px",
              marginRight: "10px",
              textAlign: "left",
            }}
          >
            {" "}
            Visitor Households Matched to {segment_title_name}
            <i className="symbol symbol-tm" /> {segment_title_right}
          </div>
        </div>
        <div
          style={{
            background: "#F5F5F5",
            display: "flex",
            marginBottom: "20px",
          }}
        >
          <div style={{ padding: "20px", background: "#D9DBDD" }}>
            <strong>Household Match Flag</strong>
          </div>
          <div className="p-20 pr-10">
            <strong>Zip + 6</strong>
          </div>
          <div className="pt-20 pb-20">{splitNumber(zip11Households)()}</div>
          <div className="p-20 pr-10">
            <strong>Zip + 4</strong>
          </div>
          <div className="pt-20 pb-20">{splitNumber(zip9Households)()}</div>
        </div>
        <div style={{ position: "relative" }}>
          <ResponsiveContainer width="100%" height={360}>
            <BarChart
              data={sortData}
              margin={{
                top: 20,
                right: 0,
                left: 17,
                bottom: 20,
              }}
              maxBarSize={20}
            >
              <CartesianGrid vertical={false} strokeDasharray="3 3" />
              {/*this.state.measureIndex === 1 && (
                <ReferenceLine y={100} stroke="#000" />
              )*/}
              <XAxis
                dataKey="segmentCode"
                /*
                label={
                  <CustomizedLabel value="test" />
                }*/

                label={{
                  value: segment_title_name + "® " + segment_title_right,
                  position: "bottom",
                }}
              />
              <YAxis
                tickFormatter={item => {
                  if (this.state.measureIndex === 0)
                    return item === 0 ? item : item + "%";
                  else return parseInt(item, 10) + 100;
                }}
                domain={
                  this.state.measureIndex === 1
                    ? [dataMin => (dataMin >= 0 ? -50 : dataMin), "auto"]
                    : [0, "auto"]
                }
                label={
                  <AxisLabel
                    axisType="yAxis"
                    x={15}
                    y={170}
                    width={0}
                    height={0}
                  >
                    {this.state.measureIndex === 0
                      ? "Percent of Household Visitors"
                      : "Index"}
                  </AxisLabel>
                }
              />
              <Tooltip
                content={
                  <CustomTooltip
                    total={totalHouseholdVisitors}
                    type={sysType}
                    measure={this.state.measureIndex}
                  />
                }
                cursor={false}
              />
              <Bar
                dataKey={
                  this.state.measureIndex === 0
                    ? "pctHouseholdVisitors"
                    : "segmentIndex"
                }
                onMouseEnter={(data, index) => {
                  this.setState({ activeIndex: index });
                }}
                onMouseLeave={() => {
                  this.setState({ activeIndex: -1 });
                }}
              >
                {sortData.map((entry, index) => (
                  <Cell
                    cursor="pointer"
                    fill={
                      highLightIds.indexOf(entry.segmentCode) >= 0
                        ? "#E56E2C"
                        : "#47a1ab"
                    }
                    key={`household-segment-cell-${index}`}
                  />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
          <div
            id="chart-x-title"
            style={{
              position: "absolute",
              bottom: "0",
              height: "25px",
              left: 0,
              right: 0,
              fontWeight: "bold",
              background: "white",
              paddingLeft: "70px",
              textAlign: "center",
              display: "none",
            }}
          >
            {segment_title_name + segment_title_right + " ®"}
          </div>
        </div>
        <div
          className="text-right pr-10"
          style={{ fontSize: "16px", position: "relative" }}
        >
          <span
            style={{
              width: "16px",
              height: "16px",
              background: "#E56E2C",
              position: "absolute",
              right: "120px",
              top: "5px",
            }}
          >
            &nbsp;
          </span>
          Top Segments
        </div>
        <div
          className="light-grey-border-top mt-20 text-center pt-20"
          style={{ paddingLeft: "70px" }}
        >
          Click for more information on{" "}
          <a
            href="http://www.mybestsegments.com/"
            target="_blank"
            className="claritas_link"
          >
            MyBestSegments
          </a>{" "}
        </div>
      </div>
    );
  }
}

export default SegmentHouseHold;



// WEBPACK FOOTER //
// ./src/components/Insights/distribution/SegmentHouseHold.jsx